/// <reference path="../interfaces/MasterSlider.ts" />

module Elma.Bindings {
    declare var MSSliderEvent;

    interface IMasterSliderArgs {
        settings?: IMasterSlider.ISliderParams,
        mobileSettings?: IMasterSlider.ISliderParams,
        paddingBottom?: number
    }

    export class MasterSlider {



        private sliderActions = (element: HTMLElement, valueAccessor: () => IMasterSliderArgs, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) => {
            if (!bindingContext) {
                return;
            }

            var detectIE = () => {
                var ua = window.navigator.userAgent;
                // IE 10
                // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

                // IE 11
                // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

                // Edge 12 (Spartan)
                // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

                // Edge 13
                // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

                var msie = ua.indexOf('MSIE ');
                if (msie > 0) {
                    // IE 10 or older => return version number
                    return true;
                }

                var trident = ua.indexOf('Trident/');
                if (trident > 0) {
                    // IE 11 => return version number
                    return true;
                }

                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // Edge (IE 12+) => return version number
                    return true;
                }

                // other browser
                return false;
            }

            var isUnderTablet = typeof window.matchMedia != "undefined" ? window.matchMedia("(max-width: 1024px)").matches && window.matchMedia("(min-width: 768px)").matches : false;

            var updateSlider = (e) => {
                if (e.target) {
                    // check if the device is smaller than tablet
                    if ($(".js-collapse-btn").is(":visible") === false || isUnderTablet == false) {
                        // add height only on desktop / tablet 
                        var mySlider = $(e.target);
                        var currentViewHeight = mySlider.find(".ms-view").outerHeight();
                        var desiredViewHeight = currentViewHeight + paddingBottom;
                        mySlider.find(".ms-view").height(desiredViewHeight); // add extra height to achieve negative bottom effect on view layers
                    }
                }
            }

            var $sliderElement = $(element);
            var args = ko.unwrap(valueAccessor());
            var settings = args.settings || { width: 1600, height: 900 };
            var mobileSettings = args.mobileSettings || { width: 758, height: 570, autoplay: true };
            var paddingBottom = args.paddingBottom || 30;

            bindingContext.$data.masterslider = $sliderElement;

            if ($(".js-collapse-btn").is(":visible") && isUnderTablet == false) {
                // add mobile settings / different aspect ratio stuff like that
                $sliderElement.masterslider(mobileSettings);
            }
            else {
                if (detectIE() === true) {
                    // add different behavior for Edge and old IE to avoid slow animations in transitions
                    $.extend(settings, {
                        view: "flow",
                        instantStartLayers: true
                    });
                }

                $sliderElement.masterslider(settings);
            }

          
             $sliderElement.on(MSSliderEvent.RESIZE, updateSlider);
            
        }

        public init = this.sliderActions;
        public update = this.sliderActions;

    }
    ko.bindingHandlers['masterSlider'] = new MasterSlider();
}